import { MessageCircle } from "lucide-react";
import { BRAND, waMessage } from "@/lib/brand";

// CTA público próprio (não reutiliza o WhatsAppButton do admin).
// Props: variant="primary" | "secondary" | "pill" | "fixed-mobile", context, size
export function CTAWhatsApp({
  variant = "primary",
  context = null,
  label = "Falar no WhatsApp",
  phone = null,
  className = "",
  testid = "cta-whatsapp",
}) {
  const digits = String(phone || BRAND.whatsapp).replace(/\D/g, "") || BRAND.whatsapp;
  const text = waMessage(context);
  const href = `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;

  const base =
    "inline-flex items-center justify-center gap-2 font-medium transition-colors";
  const styles = {
    primary:
      "h-11 px-5 rounded-md bg-[#25D366] hover:bg-[#1ebe57] text-white text-sm shadow-sm",
    secondary:
      "h-11 px-5 rounded-md border border-[#083A6B]/20 text-[#083A6B] hover:bg-[#083A6B]/5 text-sm bg-transparent",
    pill:
      "h-10 px-4 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white text-sm",
    "fixed-mobile":
      "lg:hidden fixed bottom-4 inset-x-4 z-40 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white text-base shadow-lg",
  };

  return (
    <a
      data-testid={testid}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${styles[variant] || styles.primary} ${className}`}
    >
      <MessageCircle size={18} strokeWidth={1.8} />
      <span>{label}</span>
    </a>
  );
}

// Botão flutuante no canto (desktop e mobile — não conflita com CTA fixo quando usado).
export function FloatingWhatsAppPublic({ context = null }) {
  const href = `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(waMessage(context))}`;
  return (
    <a
      data-testid="floating-whatsapp-public"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className="hidden lg:flex fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white items-center justify-center shadow-lg hover:scale-105 hover:bg-[#1ebe57] transition-transform"
    >
      <MessageCircle size={26} strokeWidth={1.8} />
    </a>
  );
}
